import { create, StateCreator } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'

interface IComponentVisibilityState {
    isSliderVisibleOnMobile: boolean
}

interface IComponentVisibilityStore extends IComponentVisibilityState {
    setIsSliderVisibleOnMobile: (isSliderVisibleOnMobile: boolean) => void
}
const initialComponentVisibility: IComponentVisibilityState = {
    isSliderVisibleOnMobile: true,
}

export const createComponentVisibilityStore:
    StateCreator<IComponentVisibilityStore, [['zustand/persist', unknown], ['zustand/devtools', never]]>
    = (set) => ({
        ...initialComponentVisibility,
        setIsSliderVisibleOnMobile: (isSliderVisibleOnMobile: boolean) =>
            set({ isSliderVisibleOnMobile }, undefined, 'ComponentVisibilityStore/setisSliderVisibleOnMobile'),
        reset: () => set({ ...initialComponentVisibility }, undefined, 'AccessTokenStore/reset'),
    })

export const useComponentVisibilityStore = create<IComponentVisibilityStore>()(
    persist(
        devtools(createComponentVisibilityStore, { name: 'ComponentVisibilityStore' }),
        { 
            name: 'component-visibility-storage',
            storage: createJSONStorage(() => sessionStorage),
        }
    )
)
